export default __webpack_public_path__ + "static/media/createPublicationStep4Gif.81c118dd.gif";